<template>

  <div :class="[$style.formSectionBankCard]">
    <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
      <h4 class="textColor"> Card Details</h4>
    </div>
    <FormSectionSavedCards
      v-if="innerValue.cardDataType === 'saved'"
      :cards="cards"
      v-model="innerValue.savedCardId"
      @select="emitChanges('savedCardId')"
    />
    <template v-if="innerValue.cardDataType === 'manual'">
      <UiCardField
        v-model="innerValue.cardNumber"
        ref="cardNumberField"
        name="pan"
        type="tel"
        tabindex="1"
        :class="[$style.formIte043m, { [$style._oneLine]: isOneLine }]"
        :hasError="$isFieldInvalid('innerValue.cardNumber')"
        :errorText="$t('FormSectionBankCard.cardNumberInvalid')"
        @keyup.native="moveFocusToFieldOnComplete('cardNumber', 16, 'expiryDateField')"
        @input="emitChanges('cardNumber')"
      />
      <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
        <UiTextField
          v-model="innerValue.expiryDate"
          ref="expiryDateField"
          mask="##/##"
          type="tel"
          tabindex="2"
          autocomplete="off"
          :class="$style.expiry"
          :hasError="$isFieldInvalid('innerValue.expiryDate')"
          :errorText="$t('FormSectionBankCard.expiryDateInvalid')"
          :label="$t('FormSectionBankCard.expiryDate')"
          @keyup.native="moveFocusToFieldOnComplete('expiryDate', 4, 'cvvField')"
          @keyup.native.delete="moveFocusBackOnEmpty('expiryDate', 'cardNumberField')"
          @input="emitChanges('expiryDate')"
          datathreeds="expiry"
        />
        <UiCvvField
          v-model="innerValue.cvv"
          name="cvv"
          ref="cvvField"
          tabindex="3"
          :hasError="$isFieldInvalid('innerValue.cvv')"
          @keyup.native.delete="moveFocusBackOnEmpty('cvv', 'expiryDateField')"
          @input="emitChanges('cvv')"
        />
      </div>

      <!-- hidden elements -->
      <input  type="text" id="xpan"  ref="xpan"  data-threeds="pan" class="3dcardhidden" style="width: 0px;
    padding: 0px;
    height: 0px;
    margin: 0;
    border: none;"/>
      <input  type="text" id="xmonth"  ref="xmonth" data-threeds="month" class="3dcardhidden" style="width: 0px;
    padding: 0px;
    height: 0px;
    margin: 0;
    border: none;"/>
      <input   type="text" id="xyear" ref="xyear" value="" data-threeds="year" class="3dcardhidden" style="width: 0px;
    padding: 0px;
    height: 0px;
    margin: 0;
    border: none;" />

    <!-- HIdden elements -->
    <div>
      <input type="hidden" id="eci" name="eci">
      <input type="hidden" id="cavv" name="cavv">
      <input type="hidden" id="xid" name="xid">
      <input type="hidden" id="status" name="status">
      <input type="hidden" id="protocolVersion" name="protocolVersion">
    </div>
    </template>

    <SavedCardToPlainFieldsSwitch
      v-if="cards.length"
      v-model="innerValue.cardDataType"
      @change="focusCardNumberField"
    />

    <span v-if="this.statementDesc" style="font-size:12px">This charge will appear as the following on your credit card statement: "{{this.statementDesc}}" </span>

    <span v-if="!this.statementDesc" style="font-size:12px">This charge will appear as the following on your credit card statement: "{{this.name}}" </span>


    <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
      <h4>Billing Address</h4>
    </div>


<div v-if="testhide" class="billingfields">
    <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
      <UiTextField
        v-model="innerValue.firstname"
        name="First Name"
        :class="$style.formItem"
        :label="$t('FormSectionBankCard.firstname')"
        :hasError="$isFieldInvalid('innerValue.firstname')"
        :errorText="$t('FormSectionBankCard.firstnameInvalid')"
        tabindex="4"
        @input="emitChanges('firstname')"
      />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

      <UiTextField
        v-model="innerValue.lastname"
        name="Last Name"
        :class="$style.formItem"
        :label="$t('FormSectionBankCard.lastname')"
        :hasError="$isFieldInvalid('innerValue.lastname')"
        :errorText="$t('FormSectionBankCard.lastnameInvalid')"
        tabindex="5"
        @input="emitChanges('lastname')"
      />
    </div>


  <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
    <UiTextField
      v-model="innerValue.addressline1"
      name="Address Line 1"
      :class="$style.formItem"
      :label="$t('FormSectionBankCard.addressline1')"
      :hasError="$isFieldInvalid('innerValue.addressline1')"
      :errorText="$t('FormSectionBankCard.addressline1Invalid')"
      tabindex="6"
      @input="emitChanges('addressline1')"
    />

    <UiTextField
      v-model="innerValue.addressline2"
      name="Address Line 2"
      :class="$style.formItem"
      :label="$t('FormSectionBankCard.addressline2')"
      :hasError="$isFieldInvalid('innerValue.addressline2')"
      :errorText="$t('FormSectionBankCard.addressline2Invalid')"
      tabindex="7"
      @input="emitChanges('addressline2')"
    />
  </div>

  <div :class="[$style.formItem, { [$style._oneLine]: isOneLine }]">
    <UiTextField
      v-model="innerValue.city"
      name="city"
      :class="$style.formItem"
      :label="$t('FormSectionBankCard.city')"
      :hasError="$isFieldInvalid('innerValue.city')"
      :errorText="$t('FormSectionBankCard.cityInvalid')"
      tabindex="8"
      @input="emitChanges('city')"
    />

      <UiSelect
        name="state"
        v-model="innerValue.state"
        maxHeight="240px"
        style="width: 50%;"
        :options="states"
        :placeholderLabel="$t('FormSectionBankCard.state')"
        :hasReversible="true"
        :hasError="$isFieldInvalid('innerValue.state')"
        :errorText="$t('FormSectionBankCard.stateInvalid')"
        tabindex="9"
        @select="emitChanges('state')"
      />
  </div>

    <UiTextField
        v-model="innerValue.zip"
        name="zip"
        :class="$style.formItem"
        :label="$t('FormSectionBankCard.zip')"
        :hasError="$isFieldInvalid('innerValue.zip')"
        :errorText="$t('FormSectionBankCard.zipInvalid')"
        tabindex="10"
        @input="emitChanges('zip')"
      />

    <UiTextField
            v-model="innerValue.email"
            name="email"
            :class="$style.formItem"
            :label="$t('FormSectionBankCard.email')"
            :hasError="$isFieldInvalid('innerValue.email')"
            :errorText="$t('FormSectionBankCard.emailInvalid')"
            tabindex="11"
            @input="emitChanges('email')"
        />

    <span v-if="!this.dynamicAmount && this.surcharge > 0.0" style="font-size:12px; font-weight:bold">Merchant has applied a Convenience fee of ${{this.surcharge/100}} USD to this transaction. </span>
    <span v-if="this.dynamicAmount && this.surchargePercentage > 0.0" style="font-size:12px; font-weight:bold">Merchant has applied a Convenience fee of {{this.surchargePercentage}}% to this transaction. </span>
  </div>
 </div>


</template>

<script>
import {
  email,
  required,
  maxLength,
  minLength,
} from 'vuelidate/lib/validators';
import { toInteger, extend } from 'lodash-es';
import FormSectionSavedCards from '@/components/FormSectionSavedCards.vue';
import SavedCardToPlainFieldsSwitch from '@/components/SavedCardToPlainFieldsSwitch.vue';
import UiSelect from './UiSelect.vue';
import UiTextField from './UiTextField.vue';
import UiCardField from './UiCardField.vue';
import UiSimplePreloader from './UiSimplePreloader.vue';
import UiSelectOption from './UiSelectOption.vue';
import UiCvvField from './UiCvvField.vue';

function isValidExpiryDate(date) {
  if (date.length < 2) {
    return true;
  }
  if (date.length === 2 || date.length === 3) {
    const month = toInteger(date.substring(0, 2));

    if (month < 1 || month > 12) {
      return false;
    }

    return true;
  }
  if (date.length > 4) {
    return false;
  }

  const month = toInteger(date.substring(0, 2));
  const year = toInteger(date.substring(2));

  if (month < 1 || month > 12 || year < 0 || year > 99) {
    return false;
  }

  return true;
}

export default {
  name: 'FormSectionBankCard',

  components: {
    UiCvvField,
    UiSelectOption,
    UiSimplePreloader,
    UiCardField,
    UiTextField,
    UiSelect,
    FormSectionSavedCards,
    SavedCardToPlainFieldsSwitch,
  },

  props: {
    cardNumberValidator: {
      required: true,
      type: RegExp,
    },
    /**
       * @typedef {{ cardNumber: string, expiryDate: string }} Card
       * @type {Card[]}
       */
    cards: {
      default: () => [],
      type: Array,
    },
    value: {
      type: Object,
    },
    isZipFieldExposed: {
      type: Boolean,
      required: true,
    },
    isZipInvalid: {
      type: Boolean,
      required: true,
    },
    isOneLine: {
      type: Boolean,
      default: false,
    },
    isPayEnabled: {
      type: Boolean,
      default: false,
    },
    merchantPayApiKey: {
      type: String,
      default: '',
    },
    isCvvOptional: {
      type: Boolean,
      required: true,
      default: false,
    },
    isAddressOptional: {
      type: Boolean,
      required: true,
      default: true,
    },
    statementDesc: {
      type: String,
      default: '',
    },
    surcharge: {
      type: Number,
      default: 0.0,
    },
    surchargePercentage: {
      type: Number,
      default: 0.0,
    },
    dynamicAmount: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  data() {
    return {
      states: [
        { label: 'Alabama', value: 'AL' },
        { label: 'Alaska', value: 'AK' },
        { label: 'Arizona', value: 'AZ' },
        { label: 'Arkansas', value: 'AR' },
        { label: 'California', value: 'CA' },
        { label: 'Colorado', value: 'CO' },
        { label: 'Connecticut', value: 'CT' },
        { label: 'Delaware', value: 'DE' },
        { label: 'Florida', value: 'FL' },
        { label: 'Georgia', value: 'GA' },
        { label: 'Hawaii', value: 'HI' },
        { label: 'Idaho', value: 'ID' },
        { label: 'Illinois', value: 'IL' },
        { label: 'Indiana', value: 'IN' },
        { label: 'Iowa', value: 'IA' },
        { label: 'Kansas', value: 'KS' },
        { label: 'Kentucky', value: 'KY' },
        { label: 'Louisiana', value: 'LA' },
        { label: 'Maine', value: 'ME' },
        { label: 'Maryland', value: 'MD' },
        { label: 'Massachusetts', value: 'MA' },
        { label: 'Michigan', value: 'MI' },
        { label: 'Minnesota', value: 'MN' },
        { label: 'Mississippi', value: 'MS' },
        { label: 'Missouri', value: 'MO' },
        { label: 'Montana', value: 'MT' },
        { label: 'Nebraska', value: 'NE' },
        { label: 'Nevada', value: 'NV' },
        { label: 'New Hampshire', value: 'NH' },
        { label: 'New Jersey', value: 'NJ' },
        { label: 'New Mexico', value: 'NM' },
        { label: 'New York', value: 'NY' },
        { label: 'North Carolina', value: 'NC' },
        { label: 'North Dakota', value: 'ND' },
        { label: 'Ohio', value: 'OH' },
        { label: 'Oklahoma', value: 'OK' },
        { label: 'Oregon', value: 'OR' },
        { label: 'Pennsylvania', value: 'PA' },
        { label: 'Rhode Island', value: 'RI' },
        { label: 'South Carolina', value: 'SC' },
        { label: 'South Dakota', value: 'SD' },
        { label: 'Tennessee', value: 'TN' },
        { label: 'Texas', value: 'TX' },
        { label: 'Utah', value: 'UT' },
        { label: 'Vermont', value: 'VT' },
        { label: 'Virginia', value: 'VA' },
        { label: 'Washington', value: 'WA' },
        { label: 'West Virginia', value: 'WV' },
        { label: 'Wisconsin', value: 'WI' },
        { label: 'Wyoming', value: 'WY' },
        { label: 'American Samoa', value: 'AS' },
        { label: 'District of Columbia', value: 'DC' },
        { label: 'Federated States of Micronesia', value: 'FM' },
        { label: 'Guam', value: 'GU' },
        { label: 'Marshall Islands', value: 'MH' },
        { label: 'Northern Mariana Islands', value: 'MP' },
        { label: 'Palau', value: 'PW' },
        { label: 'Puerto Rico', value: 'PR' },
        { label: 'Virgin Islands', value: 'VI' },
      ],
      innerValue: extend({}, this.value),
      isCvvInfoShown: false,
      isRememberInfoShown: false,
      innerExpiryDate: '',
      testhide: true,
    };
  },

  watch: {
    value: {
      handler(value) {
        extend(this.innerValue, value);
      },
      deep: true,
    },
  },

  validations() {
    let innerValue = {
      email: {
        required,
        email,
      },
    };
    if (this.innerValue.cardDataType === 'manual') {
      innerValue = {
        ...innerValue,
        cardNumber: {
          required,
          wrongFormatType(value) {
            return this.cardNumberValidator.test(value);
          },
        },
        expiryDate: { required, isValidExpiryDate },

        cvv: {
          minLength: minLength(3),
          maxLength: maxLength(4),
        },
        zip: {
          wrongValue(value) {
            return (/(^\d{5}$|^\d{5}-\d{4}$)|^[\s]*$/).test(value);
          },
        },
        firstname: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(50),
        },
        lastname: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(50),
        },
      };
    }

    if (this.isCvvOptional) {
      innerValue = {
        ...innerValue,
        cvv: {
          wrongValue() {
            return !this.isCvvInvalid;
          },
        },
      };
    } else {
      innerValue = {
        ...innerValue,
        cvv: {
          required,
          wrongValue() {
            return !this.isCvvInvalid;
          },
        },
      };
    }


    // address validation
    if (this.isAddressOptional) {
      innerValue = {
        ...innerValue,
        addressline1: {
          minLength: minLength(5),
          maxLength: maxLength(200),
        },
        addressline2: {
          minLength: minLength(5),
          maxLength: maxLength(200),
        },
        zip: {
          wrongValue() {
            return !this.isZipInvalid;
          },
        },
        city: {
          minLength: minLength(3),
          maxLength: maxLength(100),
        },
      };
    } else {
      innerValue = {
        ...innerValue,
        addressline1: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(200),
        },
        addressline2: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(200),
        },
        zip: {
          required,
          wrongValue() {
            return !this.isZipInvalid;
          },
        },
        city: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(100),
        },
        state: {
          required,
        },
      };
    }


    return {
      innerValue,
    };
  },

  mounted() {
    this.focusCardNumberField();
    if (this.isPayEnabled) {
      const vueCmp = this;

      const tds = new ThreeDS(
        'billing-form',
        vueCmp.merchantPayApiKey,
        null,
        {
          endpoint: 'https://api-sandbox.3dsintegrator.com/v2',
          verbose: true,
          allowRetry: true,
          addResultToForm: false,
          resolve(threeds) {
            if (threeds.protocolVersion == '1.0.2') {
              console.log('Success');
              // For v-model
              const popValue = vueCmp.getInnerValue;
              const newInnervalue = {
                ...popValue,
                eci: threeds.eci,
                cavv: threeds.cavv,
                xid: threeds.xid,
                status: threeds.status,
                protocolVersion: threeds.protocolVersion,
              };
              vueCmp.$emit('change', newInnervalue);
              console.log('value emit is done....');
            } else if (threeds.protocolVersion == '2.1.0') {
              // For v-model
              const popValue = vueCmp.getInnerValue;
              const newInnervalue = {
                ...popValue,
                eci: threeds.eci,
                authenticationValue: threeds.authenticationValue,
                status: threeds.status,
                protocolVersion: threeds.protocolVersion,
                dsTransId: threeds.dsTransId,
                acsTransId: threeds.acsTransId,
              };
              vueCmp.$emit('change', newInnervalue);
              console.log('value emit is done....');
            } else {

            }

            // close the mask here...
            document.getElementById('paybtn').disabled = false;
            document.getElementById('blinktext').style.display = 'none';
          },
          reject() {
            // close the mask here...
            document.getElementById('paybtn').disabled = false;
            document.getElementById('blinktext').style.display = 'none';
          },
        },
      );
    }
  },

  methods: {
    getInnerValue() {
      return this.innerValue;
    },
    hidemore(event) {
      // this.testhide = !this.testhide;

      const x = document.getElementById('atoggle').getAttribute('class');
      if (x === 'arrow-right') {
        document.getElementById('atoggle').classList.remove('arrow-right');
        document.getElementById('atoggle').classList.add('arrow-down');
      } else {
        document.getElementById('atoggle').classList.remove('arrow-down');
        document.getElementById('atoggle').classList.add('arrow-right');
      }
    },

    focusCardNumberField() {
      this.$nextTick(() => {
        if (this.$refs.cardNumberField) {
          this.$refs.cardNumberField.focus();
        }
      });
    },
    prepareExpiryDate() {
      const [month, year] = this.innerExpiryDate.split('/');
      this.innerValue.expiryDate = `${month}${year.length === 2 ? year : year.substr(-2)}`;
      this.emitChanges('expiryDate');
    },
    moveFocusToFieldOnComplete(fieldValueName, length, nextField) {
      if (this.innerValue[fieldValueName].length === length) {
        this.$refs[nextField].focus();
      }
    },
    moveFocusBackOnEmpty(fieldValueName, prevField) {
      if (this.$refs[prevField] && this.innerValue[fieldValueName].length === 0) {
        this.$refs[prevField].focus();
      }
    },
    emitChanges(key) {
      if (this.isPayEnabled) {
        // evaluate all three input fields and trigger blur when value is right.
        if (key == 'cardNumber') {
          document.getElementById('xpan').value = this.innerValue[key];

          if (this.innerValue[key].length == 16) {
            document.getElementById('xpan').focus();
            document.getElementById('xpan').blur();
            document.getElementById('cardpan').focus();
          }
        }

        if (key == 'expiryDate') {
          document.getElementById('xyear').value = '';
          document.getElementById('xmonth').value = '';

          if (this.innerValue[key].length == 4) {
            const date = this.innerValue[key];

            const month = toInteger(date.substring(0, 2));
            const year = toInteger(date.substring(2));

            if (month < 1 || month > 12 || year < 0 || year > 99) {
              return false;
            }

            if (month) {
              document.getElementById('xmonth').value = month;
              document.getElementById('xmonth').focus();
              document.getElementById('xmonth').blur();
            }

            if (year) {
              document.getElementById('xyear').value = year;
              document.getElementById('xyear').focus();
              document.getElementById('xyear').blur();
            }
          }
        }

        // valid scenario //Punith this needs to be changed, moved to form section
        if ((key == 'cardNumber' || key == 'expiryDate')
          && (this.innerValue.cardNumber.length == 16 && this.innerValue.expiryDate.length == 4)) {
          // trigger the UI Mask -- punith
          // commit('actionProcessing', {type: '3ds'});
          document.getElementById('paybtn').disabled = true;
          document.getElementById('blinktext').style.display = 'block';
        }
      }


      // For v-model
      this.$emit('change', this.innerValue);
      const value = this.innerValue[key];
      // to watch certain field
      this.$emit(`${key}Change`, value);
    },
    validate() {
      this.$v.$touch();
      return {
        isValid: !this.$v.$invalid,
      };
    },
  },
};
</script>
<style type="text/css">
button#paybtn:disabled {
    background-color: #d0d0d0;
}
.3dcardhidden{
  width: 0px;
    padding: 0px;
    height: 0px;
    margin: 0;
    border: none;
}

.billingfields {
  width:100%;
}
.arrow-right {
  border: solid #000;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;  transition:  .5s;
  -webkit-transform: rotate(320deg);
  margin-left:3px;
}
.arrow-down{border: solid #000;   transition:  .5s;
    border-width: 0 3px 3px 0;
    display: inline-block;
 margin-left:3px;
    padding: 3px;
    -webkit-transform: rotate(405deg);}
</style>
<style module lang="scss">
  /* arrowdown:after {*/
  /*  content: ' \2B9F';*/
  /*}*/

.formSectionBankCard {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  align-content: flex-start;
  justify-content: space-between;
}
.formItem {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;

  &._oneLine {
    width: calc(50% - 10px);
  }
}
.expiry {
  @include if-ltr {
    margin-right: 20px;
  }
}
.hiddenExpiry {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  pointer-events: none;
  width: calc(50% - 10px);

  @include if-rtl {
    left: auto;
    right: 0;
  }
}
.remember {
  padding: 18px 0;
}
.rememberInfo {
  position: relative;
  display: inline-flex;
  cursor: pointer;
  margin: 0 6px;
}


</style>
